import { createFileRoute } from '@tanstack/react-router'

import { DuplicatePaymentsScreen } from './-components/duplicate-payments-screen.tsx'

export const Route = createFileRoute(
  '/transaction-monitoring/duplicate-payments'
)({
  component: DuplicatePaymentsScreen
})
